import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import "./desempeno.css";
import { usd, pct, clasePts, fmtFecha, Cobranza, Meta, Pendientes, Antiguedad, Ranking } from "./Tarjetas";

export default function Desempeno() {
  const [vend, setVend] = useState("todos");
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");

  const cargar = (v) => api.get("/desempeno", { params: { vendedor: v } }).then((r) => { setD(r.data); setErr(""); }).catch((e) => setErr(e.response?.status === 404 ? "Vendedor no encontrado" : "No se pudo cargar"));
  useEffect(() => { cargar(vend); }, [vend]);

  const toggle = async (p) => {
    try { await api.post("/desempeno/pendiente", { vendedor: vend, clave: p.clave, hecho: !p.hecho }); setD((x) => ({ ...x, pendientes: x.pendientes.map((q) => (q.clave === p.clave ? { ...q, hecho: !p.hecho } : q)) })); }
    catch { toast.error("No se pudo guardar el pendiente"); }
  };

  if (!d) return <div className="dp" data-testid="desempeno-escena"><p className="dp-sec">{err || "Cargando…"}</p></div>;
  const s = d.seleccion, equipo = d.equipo || [], esEquipo = vend === "todos";
  const kpis = esEquipo ? [["Vendedores", equipo.length], ["Clientes", s.clientes], ["Cartera", usd(s.cartera)]] : [["Clientes", s.clientes], ["% Meta del mes", pct(s.cobros_pct)], ["Cartera", usd(s.cartera)]];
  return (
    <div className="dp" data-testid="desempeno-escena">
      <div className="dp-cab">
        <div>
          <h2 className="dp-titulo" data-testid="dp-titulo">{esEquipo ? "Desempeño del equipo" : s.vendedor}</h2>
          <p className="dp-subt">{s.zona || "Zona —"} · {s.clientes} clientes · datos al {fmtFecha(d.hoy)}</p>
        </div>
        <div className="dp-kpis" data-testid="dp-kpis">{kpis.map(([t, v]) => <div className="dp-kpi" key={t}><small>{t}</small><b className="num">{v}</b></div>)}</div>
      </div>
      <div className="dp-franja" data-testid="dp-franja">
        {[["negra", "Meta del mes", s.cobros_pct], ["amarilla", "Cartera al día", s.al_dia_pct], ["rayada", "Vencido", s.vencido_pct], ["contorno", "Clientes con documentos al día", s.docs_pct]].map(([c, t, p]) => (
          <div className={`dp-pild ${c}`} key={t}><small>{t} <b className="num">{pct(p)}</b></small><div className="riel"><i style={{ width: `${Math.min(100, p ?? 0)}%` }} /></div></div>
        ))}
      </div>
      <div className="dp-grid">
        <div className="dp-izq">
          <div className={`dp-heroe ${(s.puntaje ?? 100) < 70 ? "rojo" : (s.puntaje ?? 100) < 85 ? "medio" : ""}`} data-testid="dp-heroe">
            <div className="ini">{s.iniciales}</div>
            <div className="nom">{esEquipo ? "Todo el equipo" : s.vendedor}</div>
            <div className="det">{s.clientes} clientes · {s.pagares_n} pagarés sin firma</div>
            <span className="pill num">{usd(s.cartera)}</span>
          </div>
          <div className="dp-card dp-equipo" data-testid="dp-equipo">
            <h3>Equipo</h3>
            <button className="dp-fila" aria-pressed={esEquipo} onClick={() => setVend("todos")} data-testid="dp-vend-todos"><span className="dp-av">EQ</span><span className="n">Todo el equipo</span><span className={`dp-pts ${clasePts(esEquipo ? s.puntaje : null)}`}>{esEquipo ? Math.round(s.puntaje ?? 0) : "·"}</span></button>
            {equipo.map((e, i) => (
              <button className="dp-fila" key={e.vendedor} aria-pressed={vend === e.vendedor} onClick={() => setVend(e.vendedor)} data-testid={`dp-vend-${i}`}>
                <span className="dp-av">{e.iniciales}</span><span className="n">{e.vendedor}</span><span className={`dp-pts ${clasePts(e.puntaje)}`}>{e.puntaje === null ? "—" : Math.round(e.puntaje)}</span>
              </button>
            ))}
          </div>
        </div>
        <Cobranza s={s} />
        <Meta s={s} mes={d.mes} />
        <Pendientes items={d.pendientes || []} onToggle={toggle} />
        <Antiguedad s={s} />
        <Ranking equipo={equipo} sel={vend} onSel={setVend} />
      </div>
    </div>
  );
}
